import React from 'react';
import { Link } from 'react-router-dom';
import { Span } from '../element';
import { useTranslation } from 'react-i18next';

export const WizardStepFloatedItem = ({
  path,
  menuText,
  status,
  testId,
  queryString,
}) => {
  const { t } = useTranslation();
  return (
    <Span className="wrapper">
      <Span className={status}>
        <Link className="link" to={path + queryString} data-test-id={testId}>
          <Span className="circle">
            <Span className="inner" />
          </Span>
          <Span className="label">{t(menuText)}</Span>
        </Link>
      </Span>
    </Span>
  );
};
